import { CalciteAction } from '@esri/calcite-components-react';
import { undefBoolObj, undefBool } from '../util/webComponentUtils';
import Tooltip from './Tooltip';

function Badge({ content }: { content: string }) {
  return (
    <div className="absolute flex justify-center items-center aspect-square p-0.5 w-3 h-3 right-1 bottom-1 rounded-full bg-brand text-color-inverse">
      {content}
    </div>
  );
}

export function CustomCalciteAction<T extends string>({
  panelName,
  icon,
  tooltip,
  onClick,
  selectedPanel,
  disabled,
  id,
  badgeContent,
}: {
  selectedPanel: T;
  panelName: T;
  icon: string;
  onClick: (panelName: T) => void;
  tooltip: string;
  badgeContent?: string;
  disabled?: boolean;
  id?: string;
}): JSX.Element {
  return (
    <Tooltip content={tooltip} label={tooltip} inline placement="right">
      <CalciteAction
        text={panelName}
        icon={icon}
        active={undefBool(selectedPanel === panelName)}
        onClick={() => onClick(panelName)}
        {...undefBoolObj(disabled, 'disabled')}
        id={id}
      >
        {badgeContent !== undefined && <Badge content={badgeContent} />}
      </CalciteAction>
    </Tooltip>
  );
}
